import { render, staticRenderFns } from "./CompanyServiceList.vue?vue&type=template&id=0dffe5a8&"
import script from "./CompanyServiceList.vue?vue&type=script&lang=js&"
export * from "./CompanyServiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports